import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { CONSULTATION_TYPES } from 'src/app/constant/constant';
import { ConsultationData, DietConsultationData } from 'src/app/models/consultdoctors';
import { ApiResult } from 'src/app/models/PromiseResult';
import { PatientviewService } from 'src/app/services/patientview/patientview.service';

@Component({
  selector: 'app-diet-consultation-data',
  templateUrl: './diet-consultation-data.component.html',
  styleUrls: ['./diet-consultation-data.component.css']
})
export class DietConsultationDataComponent implements OnInit {

  @Input('consultation_data')
  consultation_data: ConsultationData = new ConsultationData();

  dietConsultationData: DietConsultationData = new DietConsultationData();

  constructor(
    private readonly patientviewService: PatientviewService,
  ) { }

  ngOnInit(): void {
  }

  async init() {
    await this.getPatientDietData();
  }

  async getPatientDietData() {
    this.dietConsultationData.api_result = new ApiResult(true);
    await this.patientviewService
      .getDietData(this.consultation_data)
      .toPromise()
      .then((result) => {
        this.dietConsultationData.api_result.PromiseResult = result;
        if (result.success) {
          this.dietConsultationData.is_paid = Number(result.data.data.priority_type.amount) > 0;
          this.dietConsultationData.is_diet_consultation = result.data.data.consultation_type_id == CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
          this.dietConsultationData.patient_dietary_data = result.data.data.diet_consultation_data.patient_dietary_data;
          this.dietConsultationData.health_goal = result.data.data.diet_consultation_data.health_goal || "N/A";
          // if (this.dietConsultationData.is_paid) {
          if (Boolean(result.data.data.diet_consultation_data.other_diet_preferrence))
            this.dietConsultationData.final_diet_preferrence = result.data.data.diet_consultation_data.other_diet_preferrence;
          else if (Boolean(result.data.data.diet_consultation_data.diet_preferrence?.diet_type))
            this.dietConsultationData.final_diet_preferrence = result.data.data.diet_consultation_data.diet_preferrence.diet_type;
          else {
            this.dietConsultationData.final_diet_preferrence = "N/A"
          }
          // }
          // else {
          //   if (this.dietConsultationData.patient_dietary_data?.length > 0) {
          //     this.dietConsultationData.dietFoodData.setData(this.dietConsultationData.patient_dietary_data);
          //   }
          // }
        }
        this.dietConsultationData.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.dietConsultationData.api_result.PromiseResult.success = false;
        this.dietConsultationData.api_result.Posting = false;
        this.dietConsultationData.api_result.ServerError = error.error;
      });

  }
}
